import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { SharedModule } from '../../../shared/shared.module'
import { PriceAgreementAcceptRejectModule } from './price-agreement-accept-reject/price-agreement-accept-reject.module'
import { PriceAgreementHistoryDetailModule } from './price-agreement-history-detail/price-agreement-history-detail.module'
import { PriceAgreementHistoryModule } from './price-agreement-history/price-agreement-history.module'
import { UpdateAccountNumberComponent } from './update-account-number/update-account-number.component'

@NgModule({
  declarations: [UpdateAccountNumberComponent],
  imports: [
    PriceAgreementHistoryModule,
    PriceAgreementHistoryDetailModule,
    PriceAgreementAcceptRejectModule,
    SharedModule,
    FormsModule
  ]
})
export class PriceAgreementModule {}
